import { Component, Prop, Vue } from "vue-property-decorator";

//wrappers
import { wIcon } from "@/components/wrappers";

@Component({
  components: {
    wIcon,
  },
})
export default class ECard extends Vue {
  @Prop({ required: true }) icon!: string;
  @Prop({ required: true }) title!: string;
  @Prop({ default: "/" }) route!: string;
  @Prop({ default: true }) enabled!: boolean;

  goToRoute(): void {
    if (!this.enabled) {
      return;
    }
    if (this.route.startsWith("http")) {
      window.open(this.route, "_blank");
    } else {
      this.$router.push(this.route);
    }
  }

  get getColor(): string {
    if (!this.enabled) {
      return "e-disabled";
    }
    return "";
  }
}
